import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function Footer() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <footer ref={ref} className="w-full py-16 px-6 bg-navy-900 border-t border-navy-700" data-id="element-36">
      <div className="max-w-6xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-38">
          <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1WHdFrSi1U2g2cCzqvimde/Minimalist_Black_Leaf_Logo_%281%29.png" alt="Pericles Partners" className="w-12 h-12 mx-auto mb-4 invert opacity-90" whileHover={{
          scale: 1.1
        }} transition={{
          duration: 0.6
        }} data-id="element-39" />
          <h3 className="text-2xl font-bold mb-2 text-white" data-id="element-40">
            Pericles Partners
          </h3>
          <p className="text-slate text-sm" data-id="element-41">
            Where Weird Ideas Meet Real Money.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-sm text-slate space-y-2" data-id="element-42">
          <p data-id="element-43">Pericles Partners is a student research organization.</p>
          <p data-id="element-44">
            Nothing on this site constitutes investment advice or an offer to
            buy/sell securities.
          </p>
          <p className="mt-6" data-id="element-45">
            Contact:{' '}
            <a href="mailto:hello@pericles.capital" className="text-steel hover:text-white transition-colors" data-id="element-46">
              hello@pericles.capital
            </a>
          </p>
          <p className="text-xs text-slate/50 mt-8" data-id="element-47">
            © {new Date().getFullYear()} Pericles Partners. All rights
            reserved.
          </p>
        </motion.div>
      </div>
    </footer>;
}